<app-menu *ngIf="catalogMenu$ | async as catalogMenu" [menu]="catalogMenu" [classPrefix]="'navigation-main'">
  <div class="navigation-main-item-opener">
    <div></div>
    <div></div>
    <div></div>
  </div>
</app-menu>
